import React from "react";
import VersionText from "../../../../components/atoms/VersionText";
import {
  cropNumber,
  displayVarsomePremiumLogo,
  displayVarsomePremiumMessage,
} from "../../../../common/helpers/helpers";
import { getColor } from "./InSilicoPredictionsHelpers";
import * as urls from "./InSilicoPredictionsUrls";
import HelperText from "../../../../components/atoms/HelperText";

export const displayCaddData = (cadd, thresholds, displayCaddPremiumDB) => {
  const displayPremium =
    (displayCaddPremiumDB || __IS_COMPONENTS_PORTAL__) &&
    cadd &&
    cadd.cadd_score;
  const displayDefault = displayCaddPremiumDB === false;
  if (displayPremium || displayDefault) {
    const color =
      displayPremium && getColor("cadd", cadd.cadd_score, thresholds);
    return (
      <tr key="cadd" className="dbnsfp-row">
        <td width="20%">
          <a href={urls.caddUrl} target="_blank">
            {"CADD "}
          </a>
          <HelperText fieldDescriptionKey="CADD" />
          {displayVarsomePremiumLogo(false)}
          <br />
          {displayPremium && cadd && <VersionText versionText={cadd.version} />}
          <br />
          <span className="tw-text-3xs tw-inline-block tw-italic">
            {
              "Since version 1.6, CADD includes advance splice site prediction score, see "
            }
            <a href={urls.caddSplicingURL} target="_blank">
              publication
            </a>
          </span>
        </td>
        {displayDefault && (
          <td colSpan="6">{displayVarsomePremiumMessage()}</td>
        )}
        {displayPremium && (
          <React.Fragment>
            <td>
              <div className="varsome-horiz-list-label varsome-dbnsfp-label">
                Score
              </div>
              <div className="varsome-horiz-list-value" style={{ color }}>
                {cropNumber(cadd.cadd_score)}
              </div>
            </td>
            <td colSpan="5" />
          </React.Fragment>
        )}
      </tr>
    );
  }
  return null;
};
